import React, {useEffect} from 'react'
import {Outlet} from 'react-router-dom'

const AuthLayout = () => {
    useEffect(() => {
        const root = document.getElementById('root')
        if (root) {
            root.style.height = '100%'
        }
        return () => {
            if (root) {
                root.style.height = 'auto'
            }
        }
    }, [])

    return (
        <div style={{
            backgroundColor: "#F6F6F9",
            height: "100%",
            width: "100%",
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "fixed",
            backgroundRepeat: "no-repeat",
        }}>
            <div style={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "sticky",
                zIndex: 999
            }}>
                <Outlet/>
            </div>
        </div>
    )
}

export {AuthLayout}
